export const UPDATE_OPTIONS = 'UPDATE_OPTIONS'
export const UPDATE_USER = 'UPDATE_USER'
export const UPDATE_LIVE_TYPE = 'UPDATE_LIVE_TYPE'
export const UPDATE_LIVE_INFO = 'UPDATE_LIVE_INFO'
export const UPDATE_LIVE_URL = 'UPDATE_LIVE_URL'
export const UPDATE_FETCH_APP_USER_DATA_STATE = 'UPDATE_FETCH_APP_USER_DATA_STATE'
export const UPDATE_LIVE_CURRENT_STATE = 'UPDATE_LIVE_CURRENT_STATE'
export const UPDATE_CHANNEL_LIVE_STATE = 'UPDATE_CHANNEL_LIVE_STATE'
export const UPDATE_CHAT_READY_STATE = 'UPDATE_CHAT_READY_STATE'
export const CHECK_DEVICE = 'CHECK_DEVICE'
export const UPDATE_SERVER_TIME = 'UPDATE_SERVER_TIME'
export const UPDATE_POSTER_URL = 'UPDATE_POSTER_URL'
export const UPDATE_EMCEE = 'UPDATE_EMCEE'
export const UPDATE_VIDEO_ID = 'UPDATE_VIDEO_ID'
export const UPDATE_TRADING_VIDEO_ID = 'UPDATE_TRADING_VIDEO_ID'
export const UPDATE_PREVUE_TIME = 'UPDATE_PREVUE_TIME'

export const UPDATE_FM_LIVE_PLAY_STATE = 'UPDATE_FM_LIVE_PLAY_STATE'
export const UPDATE_FM_REPLAY_STATE = 'UPDATE_FM_REPLAY_STATE'
export const UPDATE_FM_VIDEO = 'UPDATE_FM_VIDEO'
export const UPDATE_FM_EMMEC_NOTICE = 'UPDATE_FM_EMMEC_NOTICE'
export const UPDATE_FM_SIGN_VISIBLE = 'UPDATE_FM_SIGN_VISIBLE'

export const UPDATE_WEEK_TALK_DATAS = 'UPDATE_WEEK_TALK_DATAS'

export const SET_PAGE_TYPE = 'SET_PAGE_TYPE'
export const SET_VIP_STATE = 'SET_VIP_STATE'

export const SET_TRY_FREE_REMAIN = 'SET_TRY_FREE_REMAIN'
export const SET_SERVICE_QRCODE = 'SET_SERVICE_QRCODE'
export const SET_LOCAL_TIME = 'SET_LOCAL_TIME'
export const SET_TOP_NAVS = 'SET_TOP_NAVS'
export const SET_WINDOW_WIDTH = 'SET_WINDOW_WIDTH'
export const SET_HAS_BUY_DING = 'SET_HAS_BUY_DING'
export const SET_HAS_GET_DING_INFO = 'SET_HAS_GET_DING_INFO'
export const SET_DING_SHOW_CONFIG = 'SET_DING_SHOW_CONFIG'
export const UPDATE_ROOM_INFO = 'UPDATE_ROOM_INFO'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js